<template>
  <div class="login_box">
    <el-form
      :model="loginForm"
      status-icon
      :rules="rules"
      ref="loginForm"
      label-width="100px"
      class="login_form"
    >
      <h3 class="title">成绩查询及志愿填报</h3>
      <el-form-item prop="testNum">
        <el-input
          prefix-icon="el-icon-user"
          v-model="loginForm.testNum"
          autocomplete="off"
          placeholder="请输入准考证号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          prefix-icon="el-icon-lock"
          type="password"
          v-model="loginForm.password"
          autocomplete="off"
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input
          v-model="loginForm.code"
          auto-complete="off"
          placeholder="验证码"
          style="width: 63%"
        >
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img" />
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('loginForm')"
          class="login_button"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
    <div class="el-login-footer">
      <span>Copyright © 2021-2026 yushuedu.com</span>
    </div>
  </div>
</template>

<script>
import { login, getCode, checkCode } from '@/common/apis/login'
export default {
  data() {
    return {
      loginForm: {
        testNum: '',
        password: '',
        code: '',
        uuid: ''
      },
      rules: {
        testNum: [
          { required: true, message: '请输入准考证号', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'change' }]
      },
      codeUrl: ''
    }
  },
  created() {
    this.keyupSubmit()
    this.getCode()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          checkCode(this.loginForm).then((res) => {
            if (res.data.data) {
              login(this.loginForm).then((res) => {
                if (res.data.code === '0000') {
                  this.$store.dispatch('asyncUpdateUser', {
                    token: res.data.data.token,
                    name: res.data.data.name
                  })
                  this.$router.push('/main')
                } else if (res.data.code === '0001') {
                  this.getCode()
                  this.$message.error(res.data.message)
                  return false
                }
              })
            } else {
              this.getCode()
              this.$message.error(res.data.message)
              return false
            }
          })
        }
      })
    },
    keyupSubmit() {
      document.onkeyup = (e) => {
        const _key = window.event.keyCode
        if (_key === 13) {
          this.submitForm('loginForm')
        }
      }
    },
    getCode() {
      getCode(this.loginForm).then((res) => {
        if (res.data.code === '0000') {
          this.loginForm.uuid = res.data.data.uuid
          this.codeUrl = 'data:image/gif;base64,' + res.data.data.img
        } else if (res.data.code === '0001') {
          this.$message.error(res.data.message)
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.login_box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url('../../assets/images/login-background.jpg');
}

.login_form {
  border-radius: 6px;
  background: #ffffff;
  width: 360px;
  padding: 25px 25px 5px 25px;
}

.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login_button {
  width: 100%;
}

.el-form-item {
  margin-bottom: 22px;
  margin-left: -100px;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 480px;
}

.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}

.login-code {
  width: 33%;
  height: 38px;
  float: right;
}
.login-code-img {
  height: 38px;
  margin-top: 1px;
}
</style>
